import { USER, UNIVERSITY } from '~/consts'

export default async function ({ store, redirect, app, route }) {
  const cookies = app.$cookies;
  const token = cookies.get('token')

  if (!token) {
    return redirect('/login');
  }

  let auth = store.state.auth;

  if (!auth) {
    const account_id = route.query.aid;
    if (!helpers.isEmpty(account_id)) {
      app.$axios.post(UNIVERSITY.SET_DEFAULT(account_id), {
        web_reg_id: store.state.universities.web_reg_id
      });
    }

    // GET USER DATA
    let { data } = await app.$axios.post(USER.GET_PROFILE);

    if (!helpers.isEmpty(data) && data.applicationSystem.code == 9) {
      store.commit('setState', { key: 'maintenance_message', value: data.applicationSystem.message })

      return redirect('/maintenance');
    }

    if (!(!helpers.isEmpty(data) && !helpers.isEmpty(data.data) && data.applicationSystem.code == 0)) {
      store.commit('clearAuth');
      cookies.remove('token');

      return redirect('/login');
    }

    auth = data.data;
    store.commit('setAuth', auth);
  }
}
